const direction = {
  name: "direction",
  path: "/direction",
  title: "Direction",
  description: "Utilities for controlling the text direction of an element.",
  value: {
    "direction": {
      "ltr": "ltr",
      "rtl": "rtl"
    }
  },
  exampleData: [
    {
      example: {
        code: `
<p class="ltr">This text is left-to-right (LTR).</p>
<p class="rtl">هذا النص من اليمين إلى اليسار (RTL).</p>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">ltr</code> or <code class="text-color-gray-800 dark:text-color-white font-semibold">rtl</code> to control the text direction.
      </p>
      <div class="space-y-6">
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">ltr</small>
          <p class="ltr border border-color-gray-200 p-2">This text is left-to-right (LTR).</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">rtl</small>
          <p class="rtl border border-color-gray-200 p-2">هذا النص من اليمين إلى اليسار (RTL).</p>
        </div>
      </div>
      `
    }
  ]
};

export default direction;
<div className="ltr rtl sr-only"></div>